import React from "react";
import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "./AuthContext";

// Route guard — admin-only areas. While the session is being verified we show a
// spinner; guests are bounced to the admin login; authenticated admins pass.
export default function RequireAdmin({ children }) {
  const { user } = useAuth();

  if (user === undefined) {
    return (
      <div
        className="min-h-screen bg-[#0A0A0A] text-[#B8860B] flex items-center justify-center"
        data-testid="require-admin-loading"
      >
        <Loader2 size={22} className="animate-spin" />
      </div>
    );
  }

  if (!user) return <Navigate to="/admin/login" replace />;

  return children;
}
